/** Stored on a FAILED order; the only two things a player is ever told. */
export const BookingFailureReasons = {
  Unavailable: 'unavailable',
  Error: 'error',
} as const;

export const getBookingFailureReason = (reason?: string | null) =>
  reason === BookingFailureReasons.Unavailable
    ? 'That time was no longer available at the club.'
    : 'Something went wrong on our end.';
